<template>
    <div class="myswiper-component" @mouseover="pasue" @mouseout="play">
        <ul class="myswiper-box" :style="{'width':liWidth + 'px','left': liLeft + 'px'}" :class="{'tran': noLast}">
            <template v-for="(item,index) in swiperparams">
                <li class="box-li" v-if="index%2===0">
                    <img class="img-block" :src="swiperparams[index].$img1"/>
                    <img class="img-block" v-if="swiperparams.length>index+1" :src="swiperparams[index+1].$img1"/>
                </li>
            </template>
            <template v-for="(item,index) in swiperparams">
                <li class="box-li" v-if="index%2===0">
                    <img class="img-block" :src="swiperparams[index].$img1"/>
                    <img class="img-block" v-if="swiperparams.length>index+1" :src="swiperparams[index+1].$img1"/>
                </li>
            </template>
        </ul>
        <div class="btn-box">
            <ul>
                <li @click="prev"><i class="el-icon-arrow-left"></i></li>
                <li @click="next"><i class="el-icon-arrow-right"></i></li>
            </ul>
        </div>
    </div>
</template>

<script>
    import api from '../model/api';

    export default {
        name: 'myswiper',
        components: {},
        props: {
            swiperparams: {
                type: Array
            }
        },
        data () {
            return {
                params: {},
                liLeft: 0,
                nowindex: 0,
                noLast: true,
                disabled: false,
            };
        },
        watch: {},
        computed: {
            liWidth () {
                return (Math.ceil(this.swiperparams.length)) * 198
            }
        },
        methods: {
            prev () {  // 左边的按钮
                if (this.disabled === false) {
                    this.disabled = true;
                    if (this.nowindex === 0) {
                        this.noLast = false;
                        this.nowindex = Math.ceil(this.swiperparams.length / 2);
                        this.liLeft = -this.nowindex * 198;
                    }
                    setTimeout(() => {
                        this.noLast = true;
                        this.nowindex--;
                        this.liLeft += 198;
                    }, 10);
                    setTimeout(() => {
                        this.disabled = false;
                    }, 550);
                }
            },
            next () { // 右边的按钮
                if (this.disabled === false) {
                    this.disabled = true;
                    this.noLast = true;
                    this.nowindex++;
                    this.liLeft -= 198;
                    if (this.nowindex > Math.ceil(this.swiperparams.length / 2) - 1) {
                        setTimeout(() => {
                            this.noLast = false;
                            this.liLeft = 0;
                            this.nowindex = 0;
                        }, 500);
                    }
                    setTimeout(() => {
                        this.disabled = false;
                    }, 550)
                }
            },
            autoSwitch () { //自动播放
                this.timer = setInterval(() => {
                    this.next();
                }, 3000)
            },
            pasue () { // 暂停
                clearInterval(this.timer)
            },
            play () { // 播放
                this.autoSwitch();
            },
        },
        created () {
            this.autoSwitch();
        },
        mounted () {
        }
    };
</script>

<style scoped>
    .myswiper-component {
        overflow: hidden;
        width: 1200px;
        height: 230px;
        position: relative;
        cursor: pointer;
    }

    .myswiper-box {
        height: 230px;
        position: absolute;
        top: 0;
    }

    .myswiper-component ul {
        width: 100%;
        height: 170px;
        overflow: hidden;
    }

    .myswiper-component ul li {
        float: left;
        width: 166px;
        margin-left: 16px;
        margin-right: 16px;
        margin-top: 10px;
        height: 152px;
        text-align: center;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }

    .btn-box ul {
        width: 100px;
        height: 40px;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .btn-box ul li {
        margin: 0;
        padding: 0;
        background: #000;
        border-radius: 50%;
        float: left;
        width: 40px;
        height: 40px;
        border-width: 1px;
        color: #fff;
        text-align: center;
        opacity: .5;
        cursor: pointer;
    }

    .btn-box ul li:hover {
        opacity: 1;
    }

    .btn-box {
        position: absolute;
        bottom: 0;
        left: 550px;
        width: 100px;
        height: 40px;
        text-align: center;
    }

    .tran {
        transition: all 0.5s;
    }

    .box-li {
        display: flex;
        flex-wrap: wrap;
    }

    .box-li > .img-block {
        max-width: 100%;
        height: 50%;
        border: 1px solid white;
    }
</style>



// WEBPACK FOOTER //
// src/components/myswiper.vue